export default "__VITE_ASSET__a64896fa__"